import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import type { RouteContext } from '@townsquare/router/routing-types';
import { teamsAppAgentsDirectoryRoute } from '@townsquare/routes/teams-app-agents-directory-view';

import { teamsBrowseAgentEntryPointResource } from './browse-agent-entry-point-resource';

const TeamsAppAgentDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "teamsAppAgentsDirectory-view" */ './index'),
	loading: () => null,
});

teamsAppAgentsDirectoryRoute.component = TeamsAppAgentDirectoryLoadable;
teamsAppAgentsDirectoryRoute.featureGating = {
	gates: ['rovo_agents_studio_browse_kit_home'],
	behavior: {
		type: 'override',
		override: {
			nav4Layout: 'expanded',
			resources: [teamsBrowseAgentEntryPointResource],
		},
	},
};
export const teamsAppAgentsDirectoryRouterRoute: GlobalHomePageRoute = teamsAppAgentsDirectoryRoute;
